import React from "react";
import { Datagrid, List, TextField, useListController } from "react-admin";

import { EmptyList } from "../../../../common/components";
import { report3 } from "../../Partials/Filters";
import { DownloadTopToolbarButton } from "../../../../utils/customActions";
import { REPORT_DISCOUNT_POST_OFFICE_3 } from ".";

const ListReportDisPostOffice3 = () => {
  const { filterValues, page, perPage, sort } = useListController();

  return (
    <List
      actions={
        <DownloadTopToolbarButton
          customResources={`${REPORT_DISCOUNT_POST_OFFICE_3}/download`}
          fileName={"reference-three"}
          filterParams={{ filterValues, page, perPage, sort }}
        />
      }
      filters={report3}
      filterDefaultValues={{ start_year: "2024" }}
    >
      <Datagrid
        bulkActionButtons={false}
        empty={<EmptyList />}
      >
        <TextField
          label="Издание"
          source="edition_name"
          sortable={false}
        />
        <TextField
          label="Кат. №"
          source="catalog_number"
          sortable={false}
        />
        <TextField
          label="Период"
          source="period"
        />
        <TextField
          label="Кол."
          source="quantity"
          sortable={false}
        />
        <TextField
          label="ПК"
          source="post_code"
        />
        <TextField
          label="Населено място"
          source="city"
        />
        <TextField
          label="Адрес"
          source="address"
        />
        <TextField
          label="Дата на плащане"
          source="purchase_date"
          emptyText="-"
        />
        <TextField
          label="Получател"
          source="receiver_name"
          sortable={true}
        />
      </Datagrid>
    </List>
  );
};

export default ListReportDisPostOffice3;
